import { connect } from 'react-redux';

import {
  search
} from './actions';

import {
  getProviders,
  isFetching,
  hasError
} from './reducer';

const mapStateToProps = state => {
  const { providerSearch } = state;
  return {
    getProviders: () => getProviders(state),
    isFetching: () => isFetching(state),
    hasError: () => hasError(state)
  }
};

const mapDispatchToProps = dispatch => ({
  search: (filters) => {
    dispatch(search.start(filters));
  },
});

import {
  Template
} from './components'

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Template);
